import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'
import request from '@/utils/request'

// const baseURL = process.env.VUE_APP_BASE_URL

// 新增交易公告
export function addAnnounceInfo(data) {
  return request({
    url: '/bus/tradePublicity',
    method: 'POST',
    data
  })
}

// 查询交易公告信息
export function getAnnounceInfos(param) {
  const url = handlerGetUrlParams('/bus/tradePublicity/list', param)
  return request({
    url,
    method: 'GET'
  })
}

// 获取交易公告详情
export function getAnnounceDetail(id) {
  return request({
    url: `/bus/tradePublicity/${id}`,
    method: 'GET'
  })
}

// 编辑公告
export function editAnnounceInfos(data) {
  return request({
    url: '/bus/tradePublicity',
    method: 'PUT',
    data
  })
}

// 删除公告
export function deleteAnnounceInfos(ids) {
  return request({
    url: `/bus/tradePublicity/${ids}`,
    method: 'DELETE'
  })
}

// 发布公告
export function issueAnnounceInfos(ids) {
  return request({
    url: `/bus/tradePublicity/publish/${ids}`,
    method: 'PUT'
  })
}

// 下架公告
export function dropAnnounceInfos(ids) {
  return request({
    url: `/bus/tradePublicity/drop/${ids}`,
    method: 'PUT'
  })
}
// 查询产业信息服务
export function getInfos(param) {
  const url = handlerGetUrlParams('/bus/info/list', param)
  return request({
    url,
    method: 'GET'
  })
}
// 新增产业服务信息
export function addInfo(data) {
  return request({
    url: '/bus/info',
    method: 'POST',
    data
  })
}

// 获取产业服务信息详情
export function getDetail(id) {
  return request({
    url: `/bus/info/${id}`,
    method: 'GET'
  })
}

// 编辑产业服务信息详情
export function editInfos(data) {
  return request({
    url: '/bus/info',
    method: 'PUT',
    data
  })
}
// 发布产业服务信息公告
export function editStatusInfo(data) {
  return request({
    url: '/bus/info/updateStatus',
    method: 'POST',
    data
  })
}
// 删除公告
export function deleteInfos(ids) {
  return request({
    url: `/bus/info/${ids}`,
    method: 'DELETE'
  })
}
// 根据公开号获取相关信息
export function searchInfoByPn(pn, requestCols) {
  const params = {
    modelId: '75c3b76f-1cb9-11eb-b1c6-70106fc9fcee',
    requestCols,
    searchExpre: `公开号=${pn}`,
    offset: 0,
    pageSize: 1
  }
  return request({
    url: '/data/search/query',
    method: 'POST',
    data: params
  })
}
